import { useTranslation } from 'react-i18next';

import { listSeparator } from '../../i18n/script';

import { selectionWindow, type HomeRegion, type HomeSelection, type HomeTime } from './homeState';

/** "10/17" or "10/17 至 10/18" next to each time option (PRD §3.5). */
export function useWindowText() {
  const { t } = useTranslation('activities');
  return (when: HomeTime): string => {
    if (when === 'anytime') return '';
    const { from, to } = selectionWindow({ audience: 's2', when, regions: [] });
    const short = (d?: string) => (d ? `${Number(d.slice(5, 7))}/${Number(d.slice(8, 10))}` : '');
    return from === to ? short(from) : t('when.dateRange', { from: short(from), to: short(to) });
  };
}

export function useRegionText() {
  const { t, i18n } = useTranslation(['home', 'common']);
  return (regions: HomeRegion[]): string =>
    regions.length === 0
      ? t('home:filters.allBayArea')
      : regions.map((r) => t(`common:region.${r}`)).join(listSeparator(i18n.language));
}

/** Phone summary for the sticky bar, e.g. "本周末 · 南湾" (empty when nothing is chosen). */
export function useFilterSummary() {
  const { t } = useTranslation(['home', 'common']);
  return (sel: HomeSelection): string => {
    const parts: string[] = [];
    if (sel.when !== 'anytime') parts.push(t(`home:filters.times.${sel.when}`));
    if (sel.regions.length === 1) parts.push(t(`common:region.${sel.regions[0]}`));
    else if (sel.regions.length > 1)
      parts.push(t('home:filters.regionsCount', { count: sel.regions.length }));
    return parts.join(' · ');
  };
}
